"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sharedMomentToCZ = void 0;

var _api = require("../../actions/api");

/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal
 */

/**
 * track something on churn zero
 *
 * @param {*} data
 * @param {string} [table='share']
 * @param {string} [action='push_table_change']
 * @return {*}
 */
var sharedMomentToCZ = function sharedMomentToCZ(data) {
  var table = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "share";
  var action = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "push_table_change";
  var url = "https://lapi.traceup.com/integration-".concat(process.env.REACT_APP_TRACE_ENV, "/cz/send");
  return (0, _api.post)(url, {
    action: action,
    data: {
      table: table,
      action: "insert",
      fields: data
    }
  });
};

exports.sharedMomentToCZ = sharedMomentToCZ;